import { createContext, use } from 'react';

import { type ToolDefinition, toolDefinitionToOpenAi } from '#components/chat/tool';

export interface ChatToolState {
  tools: ToolDefinition[];
}

export const ChatToolContext = createContext<ChatToolState>({ tools: [] });

export function useChatTools() {
  const { tools } = use(ChatToolContext);

  const toolsByName = new Map(tools.map((tool) => [tool.name, tool]));
  const toolDefinitions = tools?.map(toolDefinitionToOpenAi);

  return { tools, toolsByName, toolDefinitions };
}
